<template>
  <fb-form-properties-manager :fields="fields" :formId="formId" />
</template>

<script>
export default {
  name: "TextareaV1Properties",
  props: ["formId"],
  data() {
    return {
      fields: [
        {
          type: "textInput",
          properties: {
            label: "Label"
          },
          property: "label"
        },
        {
          type: "textInput",
          properties: {
            label: "Placeholder"
          },
          property: "placeholder"
        },
        {
          type: "textInput",
          properties: {
            label: "Description"
          },
          property: "description"
        },
        {
          type: "textInput",
          properties: {
            label: "Default value"
          },
          property: "value"
        },
        {
          type: "textInput",
          properties: {
            label: "Height",
            type: "number"
          },
          property: "rows"
        },
        {
          type: "checkbox",
          properties: {
            label: "Required",
            disabled: element => {
              return !(element.properties.hidden == false || element.properties.hidden == "{{!(true)}}");
            }
          },
          property: "required"
        },
        {
          type: "textInput",
          properties: {
            label: "Min length",
            type: "number"
          },
          property: "minLength"
        },
        {
          type: "textInput",
          properties: {
            label: "Max length",
            type: "number"
          },
          property: "maxLength"
        },
        {
          type: "checkbox",
          properties: {
            label: "Editable in Patient Portal"
          },
          property: "eFormEditable"
        },
        {
          type: "multipleText",
          properties: {
            label: "Predefined Responses",
            allowCollections: true
          },
          property: "responseOptions"
        },
        {
          type: "checkbox",
          properties: {
            label: "Auto Height"
          },
          property: "autoHeight"
        },
        {
          type: "conditionEditor",
          properties: {
            label: "Visibility condition",
            updateValueMiddleware: (value) => {return value.replace("{{(","{{!(")}
          },
          property: "hidden"   
        }
      ]
    };
  }
};
</script>

<style></style>
